import { Curriculum, DIRECT_ENTRY_CURRICULUM_LABELS, hasDirectEntryCurriculum } from "@repo/common-utils";
import { useCommonCurrentUser, useCurrentStudentUser } from "./api";


export const isDirectEntry = (curricula?: Curriculum[]): boolean => Boolean(curricula && curricula.length > 0 && hasDirectEntryCurriculum(curricula));

export const getNonDirectEntryCurriculum = (curricula?: Curriculum[]): Curriculum | undefined => curricula && curricula.find(curr => (!DIRECT_ENTRY_CURRICULUM_LABELS.includes(curr)) && curr !== 'Standardized Testing');
export const getDirectEntryCurriculum = (curricula?: Curriculum[]): Curriculum | undefined => curricula && curricula.find(curr => DIRECT_ENTRY_CURRICULUM_LABELS.includes(curr));

export const useIsStudent = () => {
  const { data: user } = useCommonCurrentUser();
  return Boolean(user && user.data.userType === 'student');
};

export const useIsDirectEntry = () => {
  const { data: user } = useCurrentStudentUser();
  return user ? isDirectEntry(user?.data?.studentDetails?.educationDetails?.curricula) : false;
};